import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { ADVANCED_SPECIALIZATION_SPECIALIST, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListAdvancedSpecializationSpecialist from "./List";
import ShowAdvancedSpecializationSpecialist from "./Show/Show";
import CreateAdvancedSpecializationSpecialist from "./Create";
import EditAdvancedSpecializationSpecialist from "./Edit";

export const resources = {
  isMenu: true,
  icon: <WorkspacePremiumIcon />,
  name: SpecialistServicePath + ADVANCED_SPECIALIZATION_SPECIALIST,
  title: "ВСД специализанти",
  list: <ListAdvancedSpecializationSpecialist />,
  show: <ShowAdvancedSpecializationSpecialist />,
  create: <CreateAdvancedSpecializationSpecialist />,
  edit: <EditAdvancedSpecializationSpecialist />,
  permission: permissions.canPreviewAdvancedSpecializationSpecialists,
  showPermission: permissions.canPreviewAdvancedSpecializationSpecialists,
  createPermission: permissions.canManageAdvancedSpecializationSpecialists,
  editPermission: permissions.canManageAdvancedSpecializationSpecialists,
};
